/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { autopilotPlanStepSchema } from '../getAutopilotStatusV1/get-autopilot-status-v1-response';

const autopilotPlanDetailDataSchema = z.object({
  planDate: z.string(),
  status: z.string(),
  scheduledCount: z.number(),
  error: z.string().nullable().optional(),
  diagnostics: z.array(autopilotPlanStepSchema).optional().default([]),
  updatedAt: z.number(),
});

export type IAutopilotPlanDetailData = z.infer<typeof autopilotPlanDetailDataSchema>;

export const getAutopilotPlanDetailV1ResponseSchema = createApiResponseSchema(
  autopilotPlanDetailDataSchema,
) as z.ZodSchema<IAPI<IAutopilotPlanDetailData>>;

export type IGetAutopilotPlanDetailV1Response = IAPI<IAutopilotPlanDetailData>;
